<template>
  <div
    ref="target"
    class="document-page-title group !bg-transparent"
    :class="[
      {'border-b shadow' : isStuck},
      authStore.isAuthenticated ? 'top-[52px]' : 'top-0'
    ]"
  >
    <h1
      ref="page"
      class="!mb-0"
      :class="{'text-center !text-sm !font-medium duration-150' : isStuck}"
    >
      {{ title }}
    </h1>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { useAuthStore } from '@/store/index.js';

defineProps({
  title: {
    type: String,
    default: '',
  },
});

const authStore = useAuthStore();

const target = ref(null);
const isStuck = ref(false);

const handleIntersection = ([entry]) => {
  // Set `isStuck` to true when the element is NOT intersecting
  isStuck.value = !entry.isIntersecting;
};

let observer;

onMounted(() => {
  const rootMargin = authStore.isAuthenticated ? '-57px' : '-1px';

  // Create an IntersectionObserver to monitor the element's position
  observer = new IntersectionObserver(handleIntersection, {

    threshold: 1.0, // Ensure full visibility before considering it unstuck
    rootMargin: `${rootMargin} 0px 0px 0px`, // This helps with detecting the top intersection
  });

  if (target.value) {
    observer.observe(target.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

</script>
